module.exports = __webpack_public_path__ + "img/arrow-circle-down-right.112b8bf2.svg";